<template>
  <div
    class="btn-group form-control"
    :class="{ 'is-valid': inputVal !== undefined && touched }"
  >
    <button
      tabindex="0"
      v-for="(btn, index) in buttons"
      :key="index"
      class="btn btn-outline-secondary custom-active"
      :class="{ active: inputVal === btn.value }"
      @click="inputVal = btn.value"
      type="button"
    >
      {{ btn.text }}
    </button>
    <label class="label-right">{{ activeButton.label }}</label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      touched: false,
    };
  },
  props: ["value", "validation", "buttons"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    activeButton() {
      return this.buttons.find(({ value }) => value === this.inputVal);
    },
  },
  watch: {
    validation() {
      this.touched = true;
    },
  },
};
</script>

<style scoped>
.btn-group.form-control {
  border: none !important;
  padding: 0;
}

.btn-group > .btn:last-of-type {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.btn-group > .btn {
  flex: 0 1 auto;
}
.btn-group > label {
  padding: 0.375rem 0.75rem;
}
</style>
